export default __webpack_public_path__ + "static/07_嘉宾头像_刘洋-436e427922ad130a1d3cc2c48ef67e8c.png";